<div
  uiOverlay
  (click)="onSearchFieldWrapperClicked()"
  [hasBackdrop]="false"
  [matchElementWidth]="true"
  [overlayDisabled]="overlayDisabled()"
  (overlayShown)="this.overlayOpen.set(true)"
  (overlayClosed)="overlayOpen.set(false)"
  [content]="overlayContent">
  <ui-search-input
    [disabled]="isMobile()"
    (focused)="onSearchFieldFocused()"
    [class.overlay-visible]="overlayIsVisible()"
    placeholder="Sortiment durchsuchen"
    [customIcon]="overlayIsVisible() ? 'arrow-left' : null"
    [readOnly]="isMobile()"
    [searchText]="searchText()"
    (searchChanged)="onSearchChanged($event)"
    (searchSubmit)="onSearchSubmit($event)"
    (customIconClicked)="onClose()"
    (barcodeClicked)="onBarcodeClicked()">
  </ui-search-input>
</div>

<ng-template #overlayContent>
  @if (suggestions().length) {
    <div class="wrapper-overlay">
      <div class="wrapper-overlay-suggestions">
        <mat-list class="search-suggestions-list">
          @for (item of suggestions(); track item) {
            <ui-search-suggestion-card [position]="$index" (clicked)="onSuggestionClicked()" [suggestion]="item"></ui-search-suggestion-card>
          }
        </mat-list>
      </div>
    </div>
  }
</ng-template>
